import { useEffect, useState } from 'react';
import Api from 'utils/api';
import translating from './translate.json';

const reportTextTypeOptions = [
  { id: 'Static', name: 'Static' },
  { id: 'Dynamic', name: 'Dynamic' }
];

const fields = () => {
  const [geneSubCategoryOptions, setGeneSubCategoryOptions] = useState(null);

  useEffect(async () => {
    await getGeneSubCategoryOptions();
  }, []);

  const getGeneSubCategoryOptions = async () => {
    const response = await Api.get('/report-text/SubCategoris');
    const subCategoriesOptions = response.data.map((subCategory) => ({
      id: subCategory.id,
      name: subCategory.name
    }));
    console.log(subCategoriesOptions);
    setGeneSubCategoryOptions(subCategoriesOptions);
  };

  // for create/update
  return [
    {
      name: 'reportTextNo',
      label: translating.reportTextNo,
      required: true,
      breakLine: true,
      width: '100px'
    },
    {
      name: 'reportText',
      label: translating.reportText,
      type: 'textarea',
      required: true,
      breakLine: true
    },
    {
      name: 'reportTextType',
      label: translating.reportTextType,
      type: 'select',
      default: 'Static',
      options: reportTextTypeOptions,
      required: true,
      breakLine: true
    },
    {
      name: 'geneSubCategoryId',
      label: translating.geneSubCategoryName,
      type: 'select',
      default: 1,
      options: geneSubCategoryOptions,
      required: true
    }
  ];
};

export default fields;
